const relationshipRoles = [
  // 👨‍👩‍👧 Core Family
  { keyword: 'mother', aliases: ['mom', 'mum'], role: 'mother', gender: 'female', priority: 1 },
  { keyword: 'father', aliases: ['dad', 'pop', 'papa'], role: 'father', gender: 'male', priority: 1 },
  { keyword: 'daughter', aliases: [], role: 'daughter', gender: 'female', priority: 1 },
  { keyword: 'son', aliases: [], role: 'son', gender: 'male', priority: 1 },
  { keyword: 'sister', aliases: ['sis'], role: 'sister', gender: 'female', priority: 2 },
  { keyword: 'brother', aliases: ['bro'], role: 'brother', gender: 'male', priority: 2 },

  // 👵 Extended Family
  { keyword: 'aunt', aliases: [], role: 'aunt', gender: 'female', priority: 3 },
  { keyword: 'uncle', aliases: [], role: 'uncle', gender: 'male', priority: 3 },
  { keyword: 'grandmother', aliases: ['grandma', 'nana', 'granny'], role: 'grandmother', gender: 'female', priority: 3 },
  { keyword: 'grandfather', aliases: ['grandpa', 'gramps', 'pop-pop'], role: 'grandfather', gender: 'male', priority: 3 },
  { keyword: 'cousin', aliases: [], role: 'cousin', gender: 'neutral', priority: 3 },

  // ❤️ Romantic & Former
  { keyword: 'wife', aliases: [], role: 'spouse', gender: 'female', priority: 1 },
  { keyword: 'husband', aliases: [], role: 'spouse', gender: 'male', priority: 1 },
  { keyword: 'girlfriend', aliases: [], role: 'girlfriend', gender: 'female', priority: 2 },
  { keyword: 'boyfriend', aliases: [], role: 'boyfriend', gender: 'male', priority: 2 },
  { keyword: 'ex-wife', aliases: [], role: 'ex-wife', gender: 'female', priority: 2 },
  { keyword: 'ex-husband', aliases: [], role: 'ex-husband', gender: 'male', priority: 2 },

  // 🐾 Pets
  { keyword: 'dog', aliases: ['puppy', 'pupper'], role: 'dog', gender: 'n/a', priority: 4 },
  { keyword: 'cat', aliases: ['kitty', 'kitten'], role: 'cat', gender: 'n/a', priority: 4 },
  { keyword: 'pet', aliases: [], role: 'pet', gender: 'n/a', priority: 4 },
];

export default relationshipRoles;
